module.exports = __webpack_public_path__ + "media/images/icon/ico_top_mv02-ad48251729f726c05ae00065d0c292c6.svg";